import { render, staticRenderFns } from "./ModalLessonPrivateSetting.vue?vue&type=template&id=d08fb3a4&scoped=true&lang=pug&"
import script from "./ModalLessonPrivateSetting.vue?vue&type=script&lang=ts&"
export * from "./ModalLessonPrivateSetting.vue?vue&type=script&lang=ts&"
import style0 from "./ModalLessonPrivateSetting.vue?vue&type=style&index=0&id=d08fb3a4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d08fb3a4",
  null
  
)

export default component.exports